import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { useMobilePanel } from '@/components/layout/Navigation/mobile';
import { NavItem } from '@/components/layout/Navigation/sidebar/nav-item';
import { useTranslations } from '@heidi/runtime/i18n';
import { Zap } from 'lucide-react';
import { useCallback, useTransition } from 'react';

export const ProtocolsNavItem = () => {
  const { t } = useTranslations();
  const [, startTransition] = useTransition();
  const { dismissMobileSidebar } = useMobilePanel();

  const onClick = useCallback(() => {
    startTransition(() => {
      setSidebarOpenTab(undefined);
    });
    dismissMobileSidebar();
  }, [dismissMobileSidebar, startTransition]);

  return (
    <NavItem
      label={t('sidenav.protocols')}
      icon={<Zap />}
      href="/protocols"
      onClick={onClick}
      testId="sidebar-link-protocols"
    />
  );
};
